import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          onError={(e) => {
            // Gracefully handle video load failure by hiding the video element
            e.currentTarget.style.display = 'none';
          }}
        >
          <source src="https://go.screenpal.com/player/stream/cTX360nqY9U" type="video/mp4" />
        </video>
        {/* Warm gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-burgundy-dark/40 via-leather/30 to-background/70" />
        
        {/* Decorative elements */}
        <div className="absolute top-20 left-10 w-32 h-32 bg-gold/20 rounded-full blur-3xl animate-float-slow" />
        <div className="absolute bottom-40 right-20 w-48 h-48 bg-accent/20 rounded-full blur-3xl animate-float-slow" style={{ animationDelay: '2s' }} />
        <div className="absolute top-1/2 left-1/4 w-40 h-40 bg-cream/10 rounded-full blur-3xl animate-float-slow" style={{ animationDelay: '1s' }} />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-[hsl(88,50%,53%)]/20 backdrop-blur-md rounded-full border border-[hsl(88,50%,53%)]/40 mb-6 sm:mb-8 animate-slide-up">
          <Sparkles className="w-3 h-3 sm:w-4 sm:h-4 text-[hsl(88,60%,45%)]" />
          <span className="text-white font-lora text-xs sm:text-sm">Meșteșug autentic din 2002</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold mb-4 sm:mb-6 text-white [text-shadow:_0_4px_12px_rgb(0_0_0_/_80%),_0_2px_4px_rgb(0_0_0_/_60%)] animate-fade-in px-2">
          Cărți religioase
          <br />
          <span className="text-white [text-shadow:_0_4px_12px_rgb(0_0_0_/_80%),_0_2px_4px_rgb(0_0_0_/_60%)] inline-block font-extrabold">
            legate în piele
          </span>
        </h1>
        
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8 text-cream/90 max-w-3xl mx-auto drop-shadow-lg font-lora leading-relaxed animate-fade-in px-4" style={{ animationDelay: '0.2s' }}>
          Artă și spiritualitate unite în fiecare pagină. 
          <br className="hidden sm:block" />
          Fiecare carte este o capodoperă creată manual cu pasiune și dedicație.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center animate-fade-in px-4" style={{ animationDelay: '0.4s' }}>
          <Button 
            size="lg" 
            onClick={() => navigate('/magazin')}
            className="bg-primary hover:bg-primary/90 text-cream text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 shadow-2xl hover-scale hover-glow-gold group w-full sm:w-auto relative overflow-hidden"
          >
            <span className="relative z-10 flex items-center">
              Vizitează Magazinul
              <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5 group-hover:translate-x-1 transition-transform" />
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            onClick={() => navigate('/despre-noi')}
            className="bg-white/95 hover:bg-white text-burgundy-dark hover:text-burgundy-dark border-2 border-white/50 text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 hover-scale w-full sm:w-auto hover:border-gold font-semibold transition-all shadow-2xl"
          >
            Descoperă Povestea
          </Button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-cream/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-cream/50 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
